import { accountingApiSlice } from "../../features/accounting/accountingApiSlice";
import { apiSlice } from "../../features/api/apiSlice";
import { articlesSlice } from "../../features/articles/articlesSlice";
import { boardSlice } from "../../features/board/boardSlice";
import { identitySlice } from "../../features/identity/identityApi";
import { AppDispatch } from "../store";

export const resetAllApiStates = () => (dispatch: AppDispatch) => {
  dispatch(identitySlice.util.resetApiState());
  dispatch(accountingApiSlice.util.resetApiState());
  dispatch(apiSlice.util.resetApiState());
  dispatch(boardSlice.util.resetApiState());
  dispatch(articlesSlice.util.resetApiState());
};
